<div class="container" [class.w-full]="relatedToType === 'Contact'">
  <div class="container__header">
    <button mat-icon-button class="close-button" [matTooltip]="'Close'" [tabIndex]="-1" (click)="close()">
      <mat-icon [svgIcon]="'close'"></mat-icon>
    </button>
    <div class="container__header__title">{{ operation === 'create' ? 'Add' : 'Edit' }}</div>
    <div class="container__header__actions">
      <ng-container *ngIf="ui.isEditing; else startEditingContainer">
        <button mat-icon-button [matTooltip]="'Cancel editing'" (click)="toggleEditing()">
          <mat-icon>remove_circle</mat-icon>
        </button>
        <button mat-icon-button [matTooltip]="'Save changes'" [disabled]="!canSaveTemplate" (click)="saveTemplate()">
          <mat-icon>check_circle</mat-icon>
        </button>
      </ng-container>
      <ng-template #startEditingContainer>
        <ng-container *ngIf="currentFields.length">
          <button
            mat-icon-button
            [matTooltip]="'Start editing'"
            [appAuthorize]="getManageAddFormCustomObjectPermission(customObject.name)"
            (click)="toggleEditing()"
          >
            <mat-icon>edit</mat-icon>
          </button>
        </ng-container>
      </ng-template>
    </div>
  </div>

  <mat-progress-bar mode="indeterminate" [class.hidden]="!ui.isLoading"></mat-progress-bar>

  <div
    class="container__field-list"
    cdkDropList
    [cdkDropListData]="currentFields"
    (cdkDropListDropped)="dropped($event)"
    cdkDropListOrientation="vertical"
  >
    <ng-container *ngIf="!ui.isEditing">
      <mat-form-field class="flex-auto gt-xs:pr-3">
        <mat-label>{{ customObject.label }} Layout</mat-label>
        <mat-select [formControl]="template_id">
          <mat-option *ngFor="let projectTemplate of templates" [value]="projectTemplate.id">
            {{ projectTemplate.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
    <div
      *ngFor="let field of currentFields; let fieldIndex = index; let isLastField = last"
      class="container__field-list__item"
      [class.placeholder]="field.type === 'placeholder'"
      cdkDrag
      [cdkDragDisabled]="!ui.isEditing || operation === 'update' || field.type === 'placeholder'"
    >
      <div class="container__field-list__item__left">
        <mat-icon
          *ngIf="ui.isEditing && operation !== 'update' && field.type !== 'placeholder'"
          class="drag-handler"
          svgIcon="drag_indicator"
          [matTooltip]="'Drag me'"
          cdkDragHandle
        ></mat-icon>
      </div>
      <div class="container__field-list__item__center">
        <ng-container [ngSwitch]="field.type">
          <ng-container *ngSwitchCase="'fieldDef'">
            <app-form-field
              [fieldDef]="field.fieldDef"
              [model]="customObjectValue"
              [data]="data"
              [readonly]="isReadOnly(field)"
              [alwaysHideHistory]="true"
              (onUpdate)="onFieldUpdate($event)"
            ></app-form-field>
          </ng-container>
          <ng-container *ngSwitchCase="'placeholder'">
            <mat-form-field>
              <mat-label>Select a field</mat-label>
              <mat-select (selectionChange)="onFieldSelected($event)">
                <mat-option [disabled]="isSelected(field.name)" *ngFor="let field of allowedFields" [value]="field">
                  {{ field?.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </ng-container>
      </div>
      <div class="container__field-list__item__right">
        <ng-container *ngIf="ui.isEditing">
          <button
            *ngIf="currentFields.length && currentFields.length !== 1"
            mat-icon-button
            [matTooltip]="field.type === 'placeholder' ? 'Cancel' : 'Remove field'"
            (click)="removeField(fieldIndex)"
          >
            <mat-icon>remove_circle</mat-icon>
          </button>
          <button
            *ngIf="isLastField && field.type !== 'placeholder' && !ui.isAddingField"
            mat-icon-button
            [matTooltip]="'Add field'"
            (click)="addField()"
          >
            <mat-icon>add_circle</mat-icon>
          </button>
          <button
            *ngIf="field.type === 'placeholder'"
            mat-icon-button
            [matTooltip]="'Save field'"
            [disabled]="!selectedFieldDef"
            (click)="saveField(fieldIndex)"
          >
            <mat-icon>check_circle</mat-icon>
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="container__footer">
    <div class="buttons flex flex-auto justify-end">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="close()">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button
        data-cy="custom-object-value-save"
        class="save-button"
        mat-flat-button
        type="submit"
        [color]="'primary'"
        (click)="save()"
        [matTooltip]="'Save'"
        [disabled]="isSaveButtonDisabled || ui.isLoading"
      >
        Save
      </button>
    </div>
  </div>
</div>
